// The VegaPart mark (hex nut + V). Same drawing as docs/brand/vegapart-mark.svg.
export function LogoMark({ size = 28, cut = '#1e2125', title }: { size?: number; cut?: string; title?: string }) {
  return (
    <svg viewBox="0 0 120 120" width={size} height={size} className="logo-mark" role={title ? 'img' : undefined} aria-label={title} aria-hidden={title ? undefined : true}>
      <path d="M85 16.7H35L10 60L35 103.3H85L110 60Z" fill="#f59e0b" stroke="#f59e0b" strokeWidth="8" strokeLinejoin="round" />
      <path d="M33 36H49L60 68L71 36H87L67 86H53Z" fill={cut} stroke={cut} strokeWidth="2" strokeLinejoin="round" />
    </svg>
  );
}
